import React, { useState, useContext } from 'react'
import { useTranslation } from 'react-i18next'

import { DomainContext } from '../../domain-repository/DomainRepository'
import withLang from '../../withLang'

import DriverInfoHeader from '../../components/PageHeader'
import Footer from '../../components/Footer'
import TrackingPage from '../../components/TrackingPage'
import { AlertModalWithActions } from '../../components/alert-modal/AlertModal'

import { savePackBasicAction } from '../../services/Metrics'
import { SimpleCheckbox } from '../../components/legal-information-section/LegalInformation'

const CDW_EXTRA_ID = 'CDW'
const PACK_BASIC_EXTRA_ID = 'PE'

function ExclusiveReservationQuestionPage({ history, match }) {
  const { t } = useTranslation()

  const {
    getComfortExtras,
    flowNextRoute,
    reservationExtras,
    selectedExtras,
    reservation,
    getExcessForExtra,
    addExtra,
    removeExtra,
    mapExtraPrice,
    rentalAgreementQuoteValue,
    flowPreviousRoute,
    saveSessionExtra,
  } = useContext(DomainContext)

  const [loading, setLoading] = useState(false)
  const [rejectedPackBasic, setRejectedPackBasic] = useState(false)
  const [rejectedPackBasicConfirm, setRejectedPackBasicConfirm] = useState(false)

  const safeReservation = reservation || {}

  const excessNoPriceReduction = safeReservation.excessNoPriceReduction
  const cdwExcess = getExcessForExtra(CDW_EXTRA_ID)

  function valueToPay() {
    const _extra = safeReservation.availableExtras.find(e => e.extraID === PACK_BASIC_EXTRA_ID)
    const extra = _extra ? mapExtraPrice(_extra) : null
    return extra.pricePerDay || extra.totalPrice
  }

  function rejectPackBasicClick() {
    savePackBasicAction(false)
    setRejectedPackBasic(true)

    const extra = getComfortExtras(['PE'])[0]
    removeExtra(extra)

    saveSessionExtra({
      extraId: extra.extraID,
      price: extra.totalPrice,
      acquired: false,
      removedInReview: false,
      pageId: PageId,
    })
  }

  function acceptPackBasicClick() {
    if (loading) { return; }
    setLoading(true)
    savePackBasicAction(true)
    setRejectedPackBasic(false)

    const extras = getComfortExtras(['PE'])
    for (const extra of extras) {
      if (selectedExtras.find(e => e.extraID === extra.extraID) === undefined &&
        reservationExtras.find(e => e.extraID === extra.extraID) === undefined) {
        addExtra(extra)
      }
    }

    saveSessionExtra({
      extraId: extras[0].extraID,
      price: extras[0].totalPrice,
      acquired: true,
      removedInReview: false,
      pageId: PageId,
    })

    goToNextPage()
  }

  function goToNextPage() {
    history.push(flowNextRoute())
  }

  return (
    <div>
      <DriverInfoHeader
        title={t('safety')}
        active={2}
        progress={'50%'}
        handleLogoClick={() => history.push('/start')}
      />
      <main>
        <div className="container container-large">
          <div className="main-frame">
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-12 mb-2">
                  <h2 className="title">
                    {t('exclusiveQuestion1')}
                    <span className='exclusive-reservation__basic'> {t('basic')}</span>
                    {t('exclusiveQuestion2', { value: cdwExcess })}
                  </h2>
                </div>
                <div className='exclusive-reservation__value mb-2'>€{valueToPay()}/{t('day')}</div>
                <div className="container">
                  <div className="row justify-content-center">
                    <div className="col-md-6 col-8">
                      <div className="btn btn-orange w-100 p-3 mb-3" onClick={acceptPackBasicClick}>
                        {t('confirm')}
                      </div>
                    </div>
                    <div className="col-md-6 col-8">
                      <div className="btn btn-grey w-100 p-3" onClick={rejectPackBasicClick}>
                        {t('exclusiveRejectButton', { value: excessNoPriceReduction })}
                      </div>
                    </div>
                  </div>
                  {rejectedPackBasic ?
                    <SimpleCheckbox
                      value={rejectedPackBasicConfirm}
                      onChange={setRejectedPackBasicConfirm}
                      label={t('rejectPackBasicAcknowledge')}
                    />
                    : null}
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer
          nextHidden={!rejectedPackBasicConfirm}
          handlePrevClick={() => flowPreviousRoute(history)}
          handleNextClick={goToNextPage}
        />
      </main>
    </div>
  )
}

const PageId = 87
export default withLang(TrackingPage(ExclusiveReservationQuestionPage, PageId))
